'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('@ali/prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import resource from '@ali/resource';

var Index = function (_Component) {
  _inherits(Index, _Component);

  function Index(props) {
    _classCallCheck(this, Index);

    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Index, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderFrames();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unMount = true;
    }

    // 校验是否一个正确的 url

  }, {
    key: 'isUrl',
    value: function isUrl(str) {
      if (!str) return false;
      var matcher = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
      return matcher.test(str);
    }

    // 随机id

  }, {
    key: 'createRandomId',
    value: function createRandomId() {
      return (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + new Date().getTime() + '-' + Math.random().toString().substr(2, 5);
    }

    // 随机动画名称

  }, {
    key: 'createRandomAniName',
    value: function createRandomAniName() {
      return 'ani-' + this.createRandomId();
    }
  }, {
    key: 'renderFrames',
    value: function renderFrames() {
      var _this2 = this;

      var img = this.props.img;

      if (!img || !this.isUrl(img)) {
        return;
      }
      var _props = this.props,
          width = _props.width,
          height = _props.height;

      if (width > 0 && height > 0) {
        this.renderJsx(this.initParam(width, height));
        return;
      }
      var $img = document.createElement('img');
      $img.setAttribute('src', img);
      $img.onload = function () {
        var _props2 = _this2.props,
            timeHack = _props2.timeHack,
            cb = _props2.cb;

        setTimeout(function () {
          var widthImg = width > 0 ? width : $img.width; // 帧图宽
          var heightImg = height > 0 ? height : $img.height; // 帧图高
          _this2.renderJsx(_this2.initParam(widthImg, heightImg));
          if (cb) cb();
        }, timeHack >= 0 ? timeHack : 10);
      };
    }
  }, {
    key: 'initParam',
    value: function initParam(widthImg, heightImg) {
      var _props3 = this.props,
          _props3$ratio = _props3.ratio,
          ratio = _props3$ratio === undefined ? 1 : _props3$ratio,
          _props3$num = _props3.num,
          num = _props3$num === undefined ? 1 : _props3$num,
          frameArr = _props3.frameArr;

      var wImg = widthImg / 1000; // 帧图宽rem适配值
      var hImg = heightImg / 1000; // 帧图高rem适配值
      var queue = frameArr && frameArr.replace(/\s+/g, '').length > 0 ? frameArr.split(',') : null; // 自定义帧序列
      var nRun = queue ? queue.length : num; // 帧数
      var hOneFrame = heightImg / num; // 1帧高度
      var time = Math.floor(nRun * 100 * ratio * 100) / 100000; // 默认100毫秒1帧，动画时长
      var aniName = this.createRandomAniName(); // 样式
      return { wImg: wImg, hImg: hImg, queue: queue, nRun: nRun, hOneFrame: hOneFrame, time: time, aniName: aniName };
    }
  }, {
    key: 'renderJsx',
    value: function renderJsx(obj) {
      var img = this.props.img;
      var wImg = obj.wImg,
          hImg = obj.hImg,
          queue = obj.queue,
          nRun = obj.nRun,
          hOneFrame = obj.hOneFrame,
          time = obj.time,
          aniName = obj.aniName;

      var style = [];
      for (var i = 0; i < nRun; i++) {
        var percent = Math.round(i * 100 / nRun);
        var j = queue ? parseInt(queue[i]) - 1 : i;
        var posY = j * -hOneFrame / 1000;
        style.push(percent + '%' + (percent === 0 ? ',100%' : '') + '{ background-position: 0 ' + posY + 'rem; }');
      }
      style = style.join('');
      style = '@keyframes ' + aniName + ' { ' + style + ' } @-webkit-keyframes ' + aniName + ' { ' + style + ' }';
      var _hOneFrame = hOneFrame / 1000;
      // if (module.hot) {
      //   console.log('module.hot : @ali/broccoli-cmp-imgframe', { wImg, hImg, _hOneFrame, style, time });
      // }
      if (this.unMount) return;
      // jsx
      this.setState({
        framesJsx: [function () {
          return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: style }, key: '0' });
        }, function () {
          var animation = aniName + ' steps(1, end) ' + time + 's infinite';
          return _react2.default.createElement('div', { style: {
              width: wImg + 'rem',
              height: _hOneFrame + 'rem',
              backgroundImage: 'url(' + img + ')',
              backgroundSize: wImg + 'rem ' + hImg + 'rem',
              animation: animation,
              WebkitAnimation: animation
            }, key: '1' });
        }]
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var framesJsx = this.state.framesJsx;

      return _react2.default.createElement(
        'div',
        null,
        framesJsx && framesJsx.length > 0 ? framesJsx.map(function (child) {
          return child();
        }) : null
      );
    }
  }]);

  return Index;
}(_react.Component);

Index.propTypes = {
  /**
   * @title 序列帧loading图
   */
  img: _propTypes2.default.string,
  /**
   * @title 以倍数增加减少动画周期时间
   */
  ratio: _propTypes2.default.number,
  /**
   * @title 帧数
   */
  num: _propTypes2.default.number,
  /**
   * @title 帧数组，帧标示最小从1开始以逗号隔开
   */
  frameArr: _propTypes2.default.string,
  /**
   * @title 宽度（非必填）
   */
  width: _propTypes2.default.number,
  /**
   * @title 高度（非必填）
   */
  height: _propTypes2.default.number,
  /**
   * @title 图片加载成功后延迟操作，毫秒（非必填）
   */
  timeHack: _propTypes2.default.number
};
Index.defaultProps = {};
exports.default = Index;